module.exports = __webpack_public_path__ + "media/images/flags/ax-75d05f601c39c3eae4d72c17b8762a45.svg";